// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"9c0a94cf","317":"4b0a3263","743":"107792c3","917":"0bddf29f"}[chunkId] + ".chunk.js";
};